(function() {

    // The ad konows how to deal with an ad object from the server.
    Q.Ad = Q.Item.extend({
        urls: {
            create: '/api/v1/ad/create',
            read: '/api/v1/ad/get',
            update: '/api/v1/ad/edit',
            'delete': '/api/v1/ad/deactivate'
        },

        DATE_FORMAT: 'Y-m-d H:M:S',
        DATE_FIELDS: ['updated_date', 'created_date'],

        FIELDS: {
            create: ['advertisable', 'file', 'name', 'destination_url', 'type',
                     'html', 'ad_format'],
            update: ['name', 'destination_url', 'is_active', 'status', 'html',
                     'click_tracking_leniency', 'headline', 'body',
                     'font_color', 'background_color', 'font', 'product_stream'],
            read: [],
            'delete': []
        },

        parse: function(data) {
            // On edit, it gives us a replacement and an original.
            if (data.results && data.results.replacement) {
                return data.results.replacement;
            }
            if (data.results && data.results.original) {
                return data.results.original;
            }

            // the rest of the time just use results.
            return data.results;
        },

        initialize: function(m, opts) {
            Q.Ad.__super__.initialize.call(this, m, opts)
            // backbone initializes with silent:true, so we need to validate by
            // hand initially
            this.validate(this.attributes);
        },

        // updates the flashvars based on a product stream if present.
        // Put a collection of streams on Q.Ad.productStreams to allow this to
        // work.
        _getFlashVars: function(attrs) {
            var fv = this.attributes.flashvars;
            var stream;
            var filter;
            var ps;
            var fv = fv ? _.clone(fv) : {};

            attrs = attrs || this.attributes;

            // the user can explicitly set the streams.
            ps = Q.Ad.productStreams;
            if (ps) {
                // try to find the ad's stream
                stream = ps.get(attrs.product_stream);
                if (stream) {
                    //if we do, use the stream's data
                    fv.algorithms = stream.get('algorithms');
                    fv.default_products = stream.get('default_products');
                    if ((filter = stream.get('include'))) {
                        for (var k in filter) {
                            fv['include_' + k] = filter[k];
                        }
                    }
                    if ((filter = stream.get('exclude'))) {
                        for (var k in filter) {
                            fv['exclude_' + k] = filter[k];
                        }
                    }
                }
                else {
                    // otherwise remove the product stream data.
                    remove = ['default_products', 'algorithms', 'include_.+', 'exclude_.+'].join('|');
                    remove = new RegExp(remove);
                    for (var k in fv) {
                        if (remove.test(k)) {
                            delete fv[k];
                        }
                    }
                }
            }

            return fv;
        },

        // Validation is called before things are set into the attrs dict.
        // We hook this to convert any string dates to date objects.
        // This is not called if someone calls set() with silent:true!
        validate: function(attrs) {
            for (var i = 0; i < this.DATE_FIELDS.length; i++) {
                var f = this.DATE_FIELDS[i]
                if (f in attrs) {
                    attrs[f] = $.parseDate(attrs[f], this.DATE_FORMAT, true);
                }
            }
            if ('product_stream' in attrs) {
                attrs.flashvars = this._getFlashVars(attrs);
            }
        },

        toJSON: function(method) {
            var d = _.extract(this.attributes, ['id'].concat(this.FIELDS[method]));
            d.ad = d.id;
            //handle the nulls. Otherwise it will send up 'null' strings. BAD.
            for (var k in d) {
                if (d[k] == null) {
                    d[k] = ''
                }
            }

            return d;
        }
    });

    Q.Ads = Q.PagedItems.extend({
        model: Q.Ad
    });

})();
